/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import template from './floor-price.component.html';
import {getTargetingTypeTitle} from '../../targeting/targeting-constants';

@Component({
  standalone: false,
  selector: 'adn-floor-price',
  template
})
export class FloorPriceComponent {
  @Input() floorPrices: any;

  targetingTypeLabel(tt: any): string {
    return getTargetingTypeTitle(tt);
  }

  // API may return one size object or an array of them.
  sizeDimensions(sizes: any): number[][] {
    if (!sizes) {
      return [];
    }
    const entries = Array.isArray(sizes) ? sizes : [sizes];
    return entries
      .map((size) => Array.isArray(size) ? size : size?.dimensions)
      .filter((dims) => Array.isArray(dims) && dims.length >= 2 && typeof dims[0] === 'number');
  }
}
